import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import META from '../_json/_meta.json';
import LocaleService from './services/LocaleService';

const PageHelmet = ({ lang, location, id }) =>
{
	const [pageData, setPageData] = useState(null);
	const { title, description, url } = META[lang] || META.ja;

	useEffect(() =>
	{
		const loadPageData = async () =>
		{
			let item = null;
			let pageTitle = title;
			let ogUrl = url;
			let twitterUrl = url;

			if (location.pathname.startsWith('/building/'))
			{
				item = LocaleService.getItemData(lang, 'buildings', parseInt(id));
				if (item)
				{
					pageTitle = `${item.name} | ${title}`;
					ogUrl = `${url}/building/${id}`;
					twitterUrl = `${url}/building/${id}`;
				}
			}
			else if (location.pathname.startsWith('/exterior/'))
			{
				item = LocaleService.getItemData(lang, 'exteriors', parseInt(id));
				if (item)
				{
					pageTitle = `${item.name} | ${title}`;
					ogUrl = `${url}/exterior/${id}`;
					twitterUrl = `${url}/exterior/${id}`;
				}
			}
			else if (location.pathname.startsWith('/restaurant/'))
			{
				item = LocaleService.getItemData(lang, 'restaurants', parseInt(id));
				if (item)
				{
					pageTitle = `${item.name} | ${title}`;
					ogUrl = `${url}/restaurant/${id}`;
					twitterUrl = `${url}/restaurant/${id}`;
				}
			}

			setPageData({ pageTitle, description, ogUrl, twitterUrl });
		};

		loadPageData();
	}, 
	[lang, location.pathname, id, title, description, url]);

	// Show default meta while loading
	const currentData = pageData || { pageTitle: title, description, ogUrl: url, twitterUrl: url };

	return (
		<Helmet>
			<title>{currentData.pageTitle}</title>
			<meta name="description" content={currentData.description} />
			<meta property="og:title" content={currentData.pageTitle} />
			<meta property="og:description" content={currentData.description} />
			<meta property="og:url" content={currentData.ogUrl} />
			<meta name="twitter:title" content={currentData.pageTitle} />
			<meta name="twitter:description" content={currentData.description} />
			<meta name="twitter:url" content={currentData.twitterUrl} />
		</Helmet>
	);
};

export default PageHelmet;